/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { GetService } from '../../../dataservices/get.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { FileUploadService } from '../../../dataservices/file-upload.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Web Cme Vault Add Skp Points Component
 */
@Component({
  selector: 'app-web-cme-vault-add-skp-points',
  templateUrl: './web-cme-vault-add-skp-points.component.html',
  styleUrls: ['./web-cme-vault-add-skp-points.component.scss']
})
export class WebCmeVaultAddSkpPointsComponent implements OnInit, OnDestroy {
  @Input() skpPointData;
  @Output() resetConfirmModal = new EventEmitter();
  @Output() resetModalskp = new EventEmitter();
  public add_offline_cme_api_in_process = false;
  public dropdownList = [];
  public selectedItems = [];
  public dropdownSettings = {};
  public showColor = false;
  public err_msg_file = '';
  public uploadfilearray = [];
  public uploadcounter = 0;
  public error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };
  public uploadFile_api_in_process = false;
  public url = '';
  public upload_file_data = { preview: '', absolute_url: '', file_url: '', media_type: '' };
  public title = '';
  public point = '';
  public frm_issue_date;
  public frm_eissue_date;
  public bsValue = new Date();
  public bsRangeValue: Date[];
  public minDate: Date = new Date('01/01/2007');
  public maxDate: Date = new Date();
  public sminDate: Date = new Date('01/01/2007');
  public smaxDate: Date = new Date();
  public eminDate: Date = new Date('01/01/2007');
  public emaxDate: Date = new Date();
  public isValidStartDate = true;
  public isValidEndDate = true;
  public is_disable_start_date = false;
  public is_disable_end_date = false;
  public start_date_placeholder: string = (this.mls.is_lskey_display == 1) ? '(add_skp_points.key11)' : this.mls.languageText.add_skp_points.key11;
  public end_date_placeholder: string = (this.mls.is_lskey_display == 1) ? '(add_skp_points.key12)' : this.mls.languageText.add_skp_points.key12;
  public start_date_err_msg: string = (this.mls.is_lskey_display == 1) ? '(add_skp_points.key13)' : this.mls.languageText.add_skp_points.key13;
  public end_date_err_msg: string = (this.mls.is_lskey_display == 1) ? '(add_skp_points.key14)' : this.mls.languageText.add_skp_points.key14;
  public isSkpModalShown = true;
  public confirmAction = false;
  public d;
  public default_start_date;
  public default_end_date;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();


  /**
   * Necessary instances.
   */
  constructor(
    private postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    private fileus: FileUploadService,
    public fcs: FunCollectionService,
    private dss: DataStorageService,
    private getSer: GetService,
    public multiLangService: MultiLangService,
    public masterService: MasterserviceService,
    public mls: NewLanguageService) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.dss.temp_post_media = [];
    this.dropdownSettings = {
      singleSelection: true,
      text: (this.mls.is_lskey_display == 1) ? '(add_skp_points.key15)' : this.mls.languageText.add_skp_points.key15,
      enableSearchFilter: false,
      showCheckbox: false,
      enableCheckAll: false,
      primaryKey: 'source_id'
    };
    this.getCmeSourceList();
    this.subscriptions.add(this.fileus.fileUploadProcess.subscribe(data => {
      if (data != '' && data != undefined) {

        if (data.total == data.uploaded) {
          this.uploadFile_api_in_process = false;
          this.upload_file_data.file_url = data.media.media_url;
          this.upload_file_data.media_type = data.media.media_type;
          if (this.skpPointData.action == 'add') {
            this.addOfflineCme();
          } else if (this.skpPointData.action == 'edit') {
            this.updateOfflineCme();
          }
        }
      }
    }));

    if (this.skpPointData.action == 'edit') {
      this.title = this.skpPointData.data.course_name;
      const x = { local: this.skpPointData.data.certificate_url, obj: this.skpPointData.data.certificate_url };
      this.dss.temp_post_media.push(x);
      this.default_start_date = new Date(this.skpPointData.data.date_of_submission);
      this.default_end_date = new Date(this.skpPointData.data.end_date);
    }
  }

  /**
   * set Date
   */
  setDate(dateObj): void {
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };

    if (dateObj.dateFor == 'startDate') {
      this.isValidStartDate = true;
      this.frm_issue_date = dateObj.Date;
      if (this.frm_issue_date) {
        this.eminDate = this.frm_issue_date;
        this.is_disable_end_date = false;
      }
    } else {
      this.isValidEndDate = true;
      this.frm_eissue_date = dateObj.Date;
    }
  }

  /**
   * show Modal
   */
  showModal(): void {
    this.isSkpModalShown = true;
  }

  /**
   * hide Modal
   */
  hideModal(): void {
    this.isSkpModalShown = false;
    this.dss.temp_post_media = [];
    const temp = { isShow: false, action: 'add', data: '', index: '', point: 0, action_for: '' };
    this.dss.isSkpModalShown.next(temp);
  }

  /**
   * onHidden
   */
  onHidden(): void {
    this.isSkpModalShown = false;
    const temp = { isShow: false, action: 'add', data: '', index: '', point: 0, action_for: '' };
    this.dss.isSkpModalShown.next(temp);
  }

  /**
   * get Cme Source List
   */
  getCmeSourceList(): void {
    this.subscriptions.add(this.getSer.getCmeSourceList().subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.dss.cme_source_list = data.data.sources;
          this.dropdownList = this.dss.cme_source_list;

          if (this.skpPointData.action == 'edit') {
            this.title = this.skpPointData.data.course_name;
            const x = { local: this.skpPointData.data.certificate_url, obj: this.skpPointData.data.certificate_url };
            this.dss.temp_post_media.push(x);
            const temp = this.dropdownList.find(x => x.source_id == this.skpPointData.data.source_id);
            this.selectedItems.push(temp);
          }
        } else {
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * onSelect File
   */
  onSelectFile(event): void {
    this.dss.temp_post_media = [];
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0, j = this.dss.temp_post_media.length; i < filesAmount; i++, j++) {
        let type = event.target.files[i].type;
        const filetype = type;
        type = type.split('/');
        if (filetype == 'image/jpg' || filetype == 'image/jpeg' || filetype == 'image/webp' || filetype == 'image/png' || filetype == 'application/pdf') {
          if (type[0] == 'application') {
            this.getPdfThumbnail(event.target.files[i]);
            continue;
          } else if (type[0] == 'image') {
            this.getImageThumbnail(event.target.files[i]);
            continue;
          }
        } else {
          event.target.value = '';
          this.error_msg.certificate = 'Invalid file format, please select jpg/jpeg, png, pdf file format only';
          this.dss.temp_post_media = [];
          return;
        }
      }
    }
    event.target.value = '';
  }

  /**
   * get Image Thumbnail
   */
  getImageThumbnail(imgFile): void {
    let x;
    const reader = new FileReader();
    reader.readAsDataURL(imgFile);
    reader.onloadend = function () {
      const base64data = reader.result;
      x = { local: base64data, obj: imgFile };

    };

    setTimeout(() => {
      this.dss.temp_post_media.push(x);
    }, 500);
  }

  /**
   * get Pdf Thumbnail
   */
  getPdfThumbnail(pdfFile): void {
    this.fileus.generatePdfThumbnail(pdfFile).then(data => {
      data = JSON.parse(data);
      const x = { local: data['data'], obj: pdfFile };
      this.dss.temp_post_media.push(x);
    });
  }

  /**
   * get Video Thumbnail
   */
  getVideoThumbnail(videoFile): void {
    this.fileus.generateThumbnail(videoFile).then(data => {
      data = JSON.parse(data);
      const x = { local: data['data'], obj: videoFile };
      this.dss.temp_post_media.push(x);
    });
  }

  /**
   * file Uploading Process
   */
  fileUploadingProcess(): void {
    this.point = document.querySelector<HTMLInputElement>('#frm_points').value;
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };
    if (this.title == '' || this.title == undefined) {
      this.error_msg.title = this.mls.languageText.common_text.key8;
      return;
    }
    if (this.selectedItems.length == 0) {
      this.error_msg.source = 'Please select source';
      return;
    }
    if (this.point == '' || this.point == undefined) {
      this.error_msg.point = 'Please enter point';
      return;
    }
    if (this.frm_issue_date == undefined || this.frm_issue_date == '') {
      this.error_msg.start_date = 'Please enter issue date';
      return;
    }

    if (this.frm_eissue_date == undefined || this.frm_eissue_date == '') {
      this.error_msg.end_date = 'Please enter end date';
      return;
    }

    if (this.add_offline_cme_api_in_process == true) { return; }
    this.add_offline_cme_api_in_process = true;

    if (this.skpPointData.action == 'edit' && this.dss.temp_post_media.length > 0) {
      const x = this.fcs.validURL(this.dss.temp_post_media[0].local);
      setTimeout(() => {
        if (x == true) {
          this.upload_file_data.file_url = this.skpPointData.data.certificate_url;
          this.updateOfflineCme();
          return;
        }
      }, 300);
    }
    if (this.dss.temp_post_media.length > 0) {
      for (let i = 0; i < this.dss.temp_post_media.length; i++) {
        this.uploadFile_api_in_process = true;
        const obj = Object.create(this.fileus);
        obj.initUpload(this.dss.temp_post_media[i].obj, i + 1, this.dss.temp_post_media.length);
      }
    } else {
      if (this.skpPointData.action == 'add') {
        this.error_msg.certificate = 'Please upload certificate';
        return;
      } else if (this.skpPointData.action == 'edit') {
        this.upload_file_data.file_url = this.skpPointData.data.certificate_url;
        this.updateOfflineCme();
      }
    }
  }

  /**
   * update Offline Cme
   */
  updateOfflineCme(): void {
    let start_date = new Date(this.frm_issue_date).getTime();
    start_date = start_date / 1000;

    let end_date = new Date(this.frm_eissue_date).getTime();
    end_date = end_date / 1000;
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };

    if (this.dss.subject_var_for_last_value == this.skpPointData['action_for']) {
      this.subscriptions.add(this.postSer.addOfflineCme(this.skpPointData.data.course_id, 'edit', this.title, this.point, this.upload_file_data.file_url, this.selectedItems[0].source_id, start_date, end_date).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          this.add_offline_cme_api_in_process = false;
          if (data['status'] == 1) {
            const temp = { isShow: false, action: 'add', data: data['data'], index: '', point: this.point, action_for: this.skpPointData['action_for'] };
            this.dss.isSkpModalShown.next(temp);
            document.querySelector<HTMLInputElement>('#cmeOffline')?.click();

            this.dss.user_profile_data.rewards[0].score = parseFloat(this.dss.user_profile_data.rewards[0].score) - parseFloat(this.skpPointData.data.score);

            this.dss.VaultDataSource.cme_point_data.score = parseFloat(this.dss.VaultDataSource.cme_point_data.score) - parseFloat(this.skpPointData.data.score);


            this.dss.user_profile_data.rewards[0].score = parseFloat(this.dss.user_profile_data.rewards[0].score) + parseFloat(this.point);

            this.dss.VaultDataSource.cme_point_data.score = parseFloat(this.dss.VaultDataSource.cme_point_data.score) + parseFloat(this.point);

            localStorage.setItem('VaultDataSource', JSON.stringify(this.dss.VaultDataSource));

            this.isSkpModalShown = false;
            this.fcs.showSuccess(data['msg'], 'Success');
            this.dss.temp_post_media = [];
          } else if (data['status'] == 0) {
            this.fcs.errorHandeler(data);
            this.dss.temp_post_media = [];
          }
        }, () => {
          this.add_offline_cme_api_in_process = false;
        });
      }));
    }
  }

  /**
   * add Offline Cme
   */
  addOfflineCme(): void {
    let start_date = new Date(this.frm_issue_date).getTime();
    start_date = start_date / 1000;

    let end_date = new Date(this.frm_eissue_date).getTime();
    end_date = end_date / 1000;
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };

    if (this.dss.subject_var_for_last_value == this.skpPointData['action_for']) {
      this.subscriptions.add(this.postSer.addOfflineCme('', 'add', this.title, this.point, this.upload_file_data.file_url, this.selectedItems[0].source_id, start_date, end_date).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          this.add_offline_cme_api_in_process = false;
          if (data['status'] == 1) {

            const temp = { isShow: false, action: 'add', data: data['data'], index: '', point: this.point, action_for: this.skpPointData['action_for'] };
            this.dss.isSkpModalShown.next(temp);
            document.querySelector<HTMLInputElement>('#cmeOffline')?.click();
            this.dss.temp_post_media = [];

            this.dss.user_profile_data.rewards[0].score = parseFloat(this.dss.user_profile_data.rewards[0].score) + parseFloat(this.point);
            //Commenting below part as part of WEBDC-8685
            // this.dss.VaultDataSource.cme_point_data.score = parseFloat(this.dss.VaultDataSource.cme_point_data.score) + parseFloat(this.point);
            this.dss.VaultDataSource.offline_cme.total_offline = parseFloat(this.dss.VaultDataSource.offline_cme.total_offline) + 1;

            this.isSkpModalShown = false;
            localStorage.setItem('VaultDataSource', JSON.stringify(this.dss.VaultDataSource));
            this.fcs.showSuccess(data['msg'], 'Success');
          } else if (data['status'] == 0) {
            this.fcs.errorHandeler(data);
            this.dss.temp_post_media = [];
          }
        }, () => {
          this.add_offline_cme_api_in_process = false;
        });
      }));
    }
  }

  /**
   * validate points
   */
  validate_points(event): boolean {
    this.resetErrorMsg();
    if (event.target.value == '-') {
      event.target.value = '';
      return false;
    }
    const valid = (event.target.value.match(/^-?\d*(\.\d+)?$/));
    if (valid != null) {
      let temp = event.target.value;
      temp = temp.split('.');
      if (temp.length > 1) { /* empty */ } else if (event.target.value.length > 4) {
        document.querySelector<HTMLInputElement>('#frm_points').value = event.target.value.slice(0, 4);
      } else {
        document.querySelector<HTMLInputElement>('#frm_points').value = event.target.value;
      }
    } else {
      const t = event.target.value;
      const tt = t.split('.');
      if (tt.length > 2) {
        document.querySelector<HTMLInputElement>('#frm_points').value = tt[0] + '.' + tt[1];
        return false;
      }
      if (event.target.value[event.target.value.length - 1] != '.') {
        document.querySelector<HTMLInputElement>('#frm_points').value = event.target.value.slice(0, event.target.value.length - 1);
      }
    }
  }

  /**
   * remove Certificate
   */
  removeCertificate(): void {
    this.error_msg.certificate = '';
    this.upload_file_data = { preview: '', absolute_url: '', file_url: '', media_type: '' };
    this.dss.temp_post_media = [];
  }

  /**
   * reset Error Msg
   */
  resetErrorMsg(): void {
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };
  }

  /**
   * onItem Select
   */
  onItemSelect(item): void {
    this.error_msg = { title: '', source: '', point: '', start_date: '', end_date: '', certificate: '' };
    this.selectedItems = [];
    this.selectedItems.push(item);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
